import React from 'react';
import ReadOnlyBadge from './ReadOnlyBadge';

export interface SelectOption {
  value: string | number;
  label: string;
  disabled?: boolean;
  className?: string;
}

export interface SelectProps {
  options: SelectOption[];
  label?: string;
  value: string | number;
  onChange: (value: string | number, event: React.ChangeEvent<HTMLSelectElement>) => void;
  className?: string;
  selectClassName?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  readOnly?: boolean;
  showReadOnlyBadge?: boolean;
  id?: string;
  name?: string;
  autoComplete?: string;
  'data-testid'?: string;
}

/**
 * Centralized Select component styled with shared.css .form-select and .form-select-icon
 */
export const Select: React.FC<SelectProps> = ({
  options,
  label,
  value,
  onChange,
  className = '',
  selectClassName = '',
  leftIcon,
  rightIcon,
  placeholder,
  disabled = false,
  required = false,
  readOnly = false,
  showReadOnlyBadge = false,
  ...props
}) => {
  return (
    <div className={`${className}`}>
      {label && (
        <label className="block text-sm font-medium text-foreground-muted mb-1">{label}{required && <span className="text-destructive">*</span>}</label>
      )}
      <div className="relative"> {/* Added relative positioning here */}
        {leftIcon && (
          <span className="form-input-icon-left">{leftIcon}</span>
        )}        <select
          className={`form-select ${leftIcon ? 'pl-12' : ''} ${rightIcon ? 'pr-10' : ''} ${readOnly ? 'form-select-readonly' : ''} ${selectClassName}`.trim()}
          value={value}
          onChange={e => onChange(e.target.value, e)}
          disabled={disabled || readOnly}
          required={required}
          {...props}
        >
          {placeholder && <option value="" disabled>{placeholder}</option>}
          {options.map(opt => (
            <option
              key={opt.value}
              value={opt.value}
              disabled={opt.disabled}
              className={opt.className}
            >
              {opt.label}
            </option>
          ))}
        </select>        {rightIcon && (
          <span className="form-select-icon">{rightIcon}</span>
        )}
        {readOnly && showReadOnlyBadge && <ReadOnlyBadge />}
      </div>
    </div>
  );
};

export default Select;
